import React, { useState } from "react";
import dphe_logo from "../../../Assets/Images/Logos/dphe_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavContext } from "../../../Context Api/NavContext.js";
import NavProfile from "../../NavProfile/index.js";
import { useTranslation } from "react-i18next";

const Header = React.memo(() => {
  const { t } = useTranslation();
  const { isShowBurgerMenu, setShowBurgerMenu } = useNavContext();

  return (
    <header className="w-full  bg-[#1F3A60] fixed z-40 text-white">
      <button
        className="absolute left-5 top-1/2 -translate-y-1/2  opactiy-100  md:opacity-0 transform transition-all duration-300 ease-in-out"
        onClick={(event) => {
          event.stopPropagation();
          setShowBurgerMenu(!isShowBurgerMenu);
        }}
      >
        <FontAwesomeIcon icon={faBars} size="lg" />
      </button>
      <div className="flex items-center justify-center md:justify-start gap-2 custom-w-430:gap-5 ml-5 h-24">
        <a
          href="/"
          className="bg-white rounded-full size-10 custom-w-430:size-14 sm:size-16 flex items-center justify-center"
        >
          <div className="size-6 custom-w-430:size-9 sm:size-10  flex items-center justify-center">
            <img
              src={dphe_logo}
              alt="Department Logo"
              className="w-auto h-auto"
            />
          </div>
        </a>

        <div className="text-left lg:tracking-wider">
          <b className="text-sm  custom-w-430:text-lg sm:text-3xl ">
            {t("header.title")}
          </b>
          <p className="text-[10px]  custom-w-430:text-[11px] sm:text-xs">
            {t("header.sub")}
          </p>
        </div>

        <div className="hidden md:inline absolute right-3 ">
          <NavProfile />
        </div>
      </div>
    </header>
  );
});

export default Header;